<template>
  <div class="categoriesBox">
    <headerNotice routerName="商品分类"></headerNotice>
    <!-- 头部操作栏 -->
    <div class="handleBar">
      <el-row :gutter="20">
        <el-col :span="2" :offset="2">
          <el-button type="primary" @click="openDialog">
            <i class="el-icon-plus"></i> 新增
          </el-button>
        </el-col>
      </el-row>
    </div>
    <!-- 排序列表 -->
    <div class="sortBox" v-loading="loading">
      <el-tree
        :data="itemsData"
        :draggable="true"
        :expand-on-click-node="false"
        highlight-current
        :props="{
                    children:'cates'
                }"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>{{ data.cateName }}</span>
          <span>
            <el-button type="text" v-if="node.level==1" size="mini" @click="append(node,data)">新增</el-button>
            <el-button type="text" size="mini" @click="edit(node, data)">编辑</el-button>
            <el-button type="text" size="mini" @click="remove(node, data)">删除</el-button>
          </span>
        </span>
      </el-tree>
    </div>

    <!-- dialog弹框 -->
    <el-dialog class="dialogBox" title="新增商品分类" :visible.sync="showDialog" width="30%">
      <el-form label-width="120px" v-if="formData.parentID">
        <el-form-item label="上级分类">
          <el-input readonly v-model="parentCateName"></el-input>
        </el-form-item>
      </el-form>
      <el-form label-width="120px">
        <el-form-item label="分类名称" :rules="[{'required':true}]">
          <el-input :maxlength="5" placeholder="请输入名分类名称，≤5个字" v-model="formData.cateName"></el-input>
        </el-form-item>
      </el-form>
      <el-form label-width="120px">
        <el-form-item label="分类排序">
          <el-input placeholder="请输入序号" v-model.number="formData.sort"></el-input>
        </el-form-item>
      </el-form>
      <el-form label-width="120px">
        <el-form-item label="搜索关键字">
          <el-input type="textarea" placeholder="多个关键词用英文逗号'，'隔开。" v-model="formData.words"></el-input>
        </el-form-item>
      </el-form>
      <div class="confirmBtn">
        <el-button type="primary" class="confirmBtn" @click="confirmData()">确定</el-button>
      </div>
    </el-dialog>

    <!-- dialog编辑弹框 -->
    <el-dialog class="dialogBox" title="编辑商品分类" :visible.sync="showEdit" width="30%">
      <el-form label-width="120px" v-if="formData.parentID">
        <el-form-item label="上级分类">
          <el-input readonly v-model="parentCateName"></el-input>
        </el-form-item>
      </el-form>
      <el-form label-width="120px">
        <el-form-item label="分类名称" :rules="[{'required':true}]">
          <el-input :maxlength="5" placeholder="请输入名分类名称，≤5个字" v-model="formData.cateName"></el-input>
        </el-form-item>
      </el-form>
      <el-form label-width="120px">
        <el-form-item label="分类排序">
          <el-input placeholder="请输入序号" v-model.number="formData.sort"></el-input>
        </el-form-item>
      </el-form>
      <el-form label-width="120px">
        <el-form-item label="搜索关键字">
          <el-input type="textarea" placeholder="多个关键词用英文逗号'，'隔开。" v-model="formData.words"></el-input>
        </el-form-item>
      </el-form>
      <div class="confirmBtn">
        <el-button type="primary" class="confirmBtn" @click="updateData()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  data() {
    return {
      loading: true,
      totalCount: 0, //总数据条数
      maxResultCount: 100, //默认一页显示的个数,
      showDialog: false,
      showEdit: false,
      itemsData: [],
      parentCateName: "",
      formData: {
        parentID: 0,
        cateName: "",
        words: "",
        sort: ''
      }
    };
  },
  components: {
    headerNotice
  },
  mounted() {
    this.getDatas();
  },
  methods: {
    //获取列表数据
    getDatas() {
      let self = this;
      $http.GET({
        url: this.$store.state.apiUrl + "/api/services/app/AdminCate/GetCate",
        success(res) {
          self.itemsData = res;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    //新增分类 打开弹框
    openDialog() {
      this.formData = {
        parentID: 0,
        cateName: "",
        words: "",
        sort: ''
      };
      this.showDialog = true;
    },
    //确认添加按钮
    confirmData() {
      if (!this.formData.cateName || this.formData.cateName.length == 0) {
        this.$message({
          message: "分类名称不能为空",
          type: "error"
        });
        return;
      }
      let self = this;
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/ItemCateService/CreateCate",
        data: this.formData,
        success(res) {
          self.$message({
            message: "添加成功",
            type: "success"
          });
          self.getDatas();
          self.showDialog = false;
        },
        fail(res) {}
      });
    },
    //增加分类
    append(node, data) {
      this.parentCateName = data.cateName;
      this.formData = {
        parentID: data.cateID,
        cateName: "",
        words: "",
        sort: ''
      };
      this.showDialog = true;
    },
    // 编辑面板
    edit(node, data) {
      let self = this
      if(node.level == 1) {
        this.parentCateName = '';
        this.formData = {
          parentID: 0,
          cateName: data.cateName,
          words: "",
          cateID: data.cateID,
          sort: data.sort
        };
      } else {
        this.parentCateName = node.parent.data.cateName;
        this.formData = {
          parentID: node.parent.data.cateID,
          cateName: data.cateName,
          words: '',
          cateID: data.cateID,
          sort: data.sort
        };
      }
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminCate/Deatil?cateid=" + self.formData.cateID,
        success(res) {
          self.formData.words = res.words
          self.showEdit = true;
        },
        fail(res) {}
      })
    },
    // 更新分类
    updateData() {
      if (!this.formData.cateName || this.formData.cateName.length == 0) {
        this.$message({
          message: "分类名称不能为空",
          type: "error"
        });
        return;
      }
      let self = this;
      $http.PUT({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminCate/UpdateCate",
        data: this.formData,
        success(res) {
          self.$message({
            message: "编辑成功",
            type: "success"
          });
          self.getDatas();
          self.showEdit = false;
        },
        fail(res) {}
      });
    },
    //移除分类
    remove(node, data) {
      let self = this;
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $http.DELETE({
            url:
              this.$store.state.apiUrl +
              "/api/services/app/AdminCate/DeleteCate",
            params: {
              cateID: data.cateID
            },
            success(res) {
              self.$message({
                message: "删除成功",
                type: "success"
              });
              self.getDatas();
            },
            fail(res) {}
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang='scss' scoped>
.handleBar {
  margin-top: 20px;
}
.confirmBtn {
  text-align: center;
}
</style>
<style lang="scss">
.categoriesBox {
  .sortBox {
    margin: 20px 100px;
    background: #f9f9f9;
    border: 1px solid #c5c5c5;
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
    .el-tree-node {
    }
    .el-tree-node__content {
      height: 50px;
    }
  }
}
</style>